import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const contactPageWidgets = makeDynamicConfigWidgets([
  {
    name: 'contactPagePhone',
    cols: 4,
  },
  {
    name: 'hubspotForm',
    cols: 8,
  },
]);
